import React, { useState } from "react";
import { Helmet } from 'react-helmet-async';
import { Container, Row } from "react-bootstrap";
import ProductOverlay from "./ourProducts";
import DrSajid from "../Assets/dr_mh_sajid.jpg";
import Footer from "./footer";
import "./ourteam.css";

const teamMembers = [
    {
        id: 1,
        image: DrSajid,
        role: "Founder & Director",
        name: "Dr. Mohammad Sajid",
        degree: "MBBS · MS · MCh",
        specialty: "Neurosurgeon",
        bioShort: `Dr. Mohammad Sajid is a distinguished neurosurgeon and the visionary 
        founder of Asava Pharmaceuticals. With advanced qualifications in neurosurgery, 
        he brings decades of clinical expertise and a profound understanding of patient 
        care to the pharmaceutical domain.`,
        bioExtra: `Driven by a deep commitment to bridging the gap between medicine and 
        accessible healthcare, Dr. Sajid established Asava Pharmaceuticals with the 
        mission of delivering high-quality, affordable medications to patients across 
        India. His leadership reflects an unwavering dedication to integrity, innovation, 
        and compassionate care — values that are embedded in the very foundation of the 
        organisation.`
    },
    {
        id: 2,
        image: null,
        role: "Founder & Director",
        name: "Dr. Vardan Pandey",
        degree: "MBBS · MS · MCh",
        specialty: "Neurosurgeon",
        bioShort: `Dr. Vardan Pandey is a highly accomplished neurosurgeon and Director 
        at Asava Pharmaceuticals. His clinical acumen and passion for advancing 
        neurological care have made him an invaluable pillar of the organisation's 
        leadership.`,
        bioExtra: `Dr. Pandey's expertise in complex neurosurgical procedures and his 
        research-driven approach to medicine continue to inspire the team at Asava 
        Pharmaceuticals. He plays a pivotal role in shaping the company's medical 
        strategy, ensuring that every product meets the highest standards of safety, 
        efficacy, and patient benefit. His vision for a healthier India aligns seamlessly 
        with the mission of Asava Pharmaceuticals.`
    }
];

const TeamCard = ({ member }) => {
    const [open, setOpen] = useState(false);

    return (
        <div className="team-card">
            {/* ── Image ── */}
            <div className="team-card-img-wrap">
                {member.image ? (
                    <img src={member.image} alt={member.name} />
                ) : (
                    <div style={{
                        width: '100%', height: '100%',
                        background: 'linear-gradient(145deg, rgb(80, 55, 35), rgb(130, 95, 60))',
                        display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }}>
                        <span style={{
                            fontFamily: "'Cormorant Garamond', serif",
                            fontSize: '72px',
                            fontWeight: 300,
                            color: 'rgba(245, 230, 210, 0.4)',
                            letterSpacing: '4px'
                        }}>
                            {member.name.split(' ').slice(-1)[0][0]}
                        </span>
                    </div>
                )}
                <div className="team-card-img-overlay" />
                <div className="team-card-degree-badge">{member.degree}</div>
            </div>

            {/* ── Body ── */}
            <div className="team-card-body">
                <div className="team-card-role">{member.role}</div>
                <h2 className="team-card-name">{member.name}</h2>
                <p className="team-card-specialty">{member.specialty}</p>
                <div className="team-card-divider" />

                <p className="team-card-bio">
                    <span className="team-card-bio-short">{member.bioShort}</span>
                    <span className={`team-card-bio-extra ${open ? 'open' : ''}`}>
                        {' '}{member.bioExtra}
                    </span>
                </p>

                <button
                    className={`team-read-more ${open ? 'open' : ''}`}
                    onClick={() => setOpen(!open)}
                >
                    {open ? 'Read Less' : 'Read More'}
                    <span className="team-read-more-arrow">›</span>
                </button>
            </div>
        </div>
    );
};

const Team = () => {
    return (
        <Container fluid className="team-page" style={{ padding: 0 }}>
            <Helmet>
                <title>Our Team | Asava Pharmaceutical Pvt Ltd</title>
                <meta name="description" content="Meet the expert team behind Asava Pharmaceuticals — healthcare professionals committed to delivering safe, effective medicines across India." />
                <link rel="canonical" href="https://www.asavapharma.in/ourteam" />
            </Helmet>
            <ProductOverlay
                heading="Our Team"
                eyebrow="The people behind Asava"
            />

            {/* ── Intro ── */}
            <div className="team-intro">
                <div className="team-eyebrow">Leadership</div>
                <h1 className="team-intro-heading">
                    The <span>Minds</span> Behind<br />Asava Pharmaceuticals
                </h1>
                <p className="team-intro-text">
                    Our leadership is defined by decades of surgical excellence, 
                    academic distinction, and an unrelenting commitment to patient 
                    welfare. Meet the doctors who turned a vision into a mission.
                </p>
            </div>

            {/* ── Team Cards ── */}
            <div className="team-grid">
                {teamMembers.map(member => (
                    <TeamCard key={member.id} member={member} />
                ))}
            </div>

            <Row className="team-footer-row">
                <Footer />
            </Row>
        </Container>
    );
};

export default Team;